function getRangeTypesData(start, stop, step) {
    let rangeTypesData = [];
    let key = 1;
    for(let value = start; value <= stop; value+=step, ++key){
        let rangeType = {
            key: key,
            value: value,
            name: value.toString()
        }
        rangeTypesData.push(rangeType);
    }
    return rangeTypesData;
}

function getEmulsionDosingTypes(start, stop, step){
    let emulsionDosingTypes = [];
    let key = 1;
    for(let value = start; value <= stop; value+=step, ++key){
        let emulsionDosingType = {
            key: key,
            value: value.toFixed(1),
            name: value.toFixed(1)
        }
        emulsionDosingTypes.push(emulsionDosingType);
    }
    return emulsionDosingTypes;
}

export {getRangeTypesData, getEmulsionDosingTypes}
